<div class="campaign-summary loader-wrapper">
  <form class="promo-ads-form" *ngIf="campaign">
    <section class="use-pos">
      <h1>
        {{ "brand.campaign.pos.posTitle" | translate }}
        <app-tooltip
          text="{{ 'brand.campaign.pos.titleTooltip' | translate }}"
        ></app-tooltip>
      </h1>
      <p class="question">{{ "brand.campaign.pos.question" | translate }}</p>
      <mat-radio-group
        [(ngModel)]="campaign.includePos"
        (change)="onSave($event)"
        name="POSEnabled"
        [disabled]="!campaign || !campaign.isEditable"
      >
        <mat-radio-button [value]="true">{{
          "brand.campaign.pos.yes" | translate
        }}</mat-radio-button>
        <mat-radio-button [value]="false">{{
          "brand.campaign.pos.no" | translate
        }}</mat-radio-button>
      </mat-radio-group>
    </section>
    <section class="pos-message" *ngIf="campaign.includePos">
      <p>{{ "brand.campaign.pos.info" | translate }}</p>
    </section>
  </form>
  <app-autosave-tooltip
    [running]="saving"
    [error]="savingError"
  ></app-autosave-tooltip>
  <app-loader
    [text]="'shared.loadingCampaign' | translate"
    [ngClass]="{ visible: loading }"
  ></app-loader>
</div>
